import { useRef, useState } from "react";
import type { InboxSendRequest } from "../../src/inbox-v2/contract.ts";
import type {
  DraftSendReference,
  InboxDraftSendRequest,
} from "../../src/inbox-v2/draft-send-contract.ts";

/** Saving a loaded draft is part of one deliberate Send; it cannot start a second send. */
export function useDraftSend() {
  const writing = useRef(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  return {
    busy,
    error,
    send: async (
      request: InboxSendRequest,
      dispatch: (request: InboxSendRequest | InboxDraftSendRequest) => Promise<void> | undefined,
      prepare?: () => Promise<DraftSendReference>,
    ) => {
      if (writing.current) return;
      writing.current = true;
      setBusy(true);
      setError("");
      try {
        const draft = await prepare?.();
        await dispatch(draft ? { ...request, draft } : request);
      } catch (cause) {
        setError(
          cause instanceof Error ? cause.message : "The draft could not be saved. Try again.",
        );
      } finally {
        writing.current = false;
        setBusy(false);
      }
    },
  };
}
